(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    const mainImage = root.querySelector('.op-main-image');
    const mainVideo = root.querySelector('[data-main-video]');
    const mainMedia = root.querySelector('.op-main-media');
    const thumbsTrack = root.querySelector('.op-thumbs');
    const thumbs = [...root.querySelectorAll('.op-thumb')];
    const variantId = root.querySelector('[data-variant-id]');
    const installmentVariantId = root.querySelector('[data-installment-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const selectedVariantLabel = root.querySelector('[data-selected-variant-label]');
    const variantRadios = [...root.querySelectorAll('[data-variant-radio]')];
    const colorSwatches = root.querySelector('.op-variant-images[data-color-option-index]');
    const colorOptionIndex = Number(colorSwatches?.dataset.colorOptionIndex || 0);
    const currency = colorSwatches?.dataset.currency || 'USD';
    const addButton = root.querySelector('.op-add');
    const productForm = root.querySelector('form.op-form');
    const formStatus = root.querySelector('[data-product-form-status]');
    let activeMedia = 0;

    // Product specifications are merchant-managed metafield HTML. Normalize the
    // legacy warranty sentence at render time so every bike page is consistent.
    root.querySelectorAll('[data-orion-warranty-copy]').forEach(container => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        if (!/warranty/i.test(node.nodeValue || '')) return;
        node.nodeValue = node.nodeValue
          .replace(
            /1[- ]year on the frame and 3\s*(?:mo\.?|month) warranty on motor and electr(?:ic|ical) components/gi,
            '1 year bike warranty, 6 month battery warranty'
          )
          .replace(
            /1 year bike warranty,\s*6 month battery warranty(?:\s*bike warranty,\s*6 month battery warranty)+/gi,
            '1 year bike warranty, 6 month battery warranty'
          );
      });
    });

    const cleanUrl = value => (value || '').replace(/^https?:/, '').split('?')[0];
    const formatMoney = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents || 0) / 100);
      } catch (error) {
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      }
    };
    const stopMainVideo = () => {
      if (!mainVideo) return;
      mainVideo.querySelectorAll('video').forEach(video => video.pause());
      mainVideo.innerHTML = '';
      mainVideo.hidden = true;
      if (mainImage) mainImage.hidden = false;
    };
    const setMainImage = src => {
      if (!src || !mainImage) return;
      stopMainVideo();
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      mainImage.dataset.currentSrc = cleanUrl(src);
    };
    const syncActiveThumb = src => {
      const current = cleanUrl(src || mainImage?.dataset.currentSrc || mainImage?.src);
      const matchedIndex = thumbs.findIndex(button => cleanUrl(button.dataset.mediaSrc || button.querySelector('img')?.src) === current);
      const resolvedIndex = matchedIndex >= 0 ? matchedIndex : activeMedia;
      activeMedia = resolvedIndex;
      thumbs.forEach((button, index) => button.classList.toggle('is-active', index === resolvedIndex));
    };
    const showMedia = index => {
      if (!thumbs.length || !mainImage) return;
      activeMedia = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[activeMedia];
      const src = activeThumb.dataset.mediaSrc || activeThumb.querySelector('img')?.src;
      const videoTemplate = activeThumb.querySelector('.op-video-template');
      if (videoTemplate && mainVideo) {
        mainImage.hidden = true;
        mainVideo.innerHTML = videoTemplate.innerHTML;
        mainVideo.hidden = false;
        mainVideo.querySelector('video')?.play().catch(() => {});
      } else {
        setMainImage(src);
      }
      activeMedia = thumbs.indexOf(activeThumb);
      thumbs.forEach((button, thumbIndex) => button.classList.toggle('is-active', thumbIndex === activeMedia));
      if (thumbsTrack && activeThumb) {
        const targetLeft = activeThumb.offsetLeft - (thumbsTrack.clientWidth - activeThumb.offsetWidth) / 2;
        thumbsTrack.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    };
    const selectedOptions = () => [...root.querySelectorAll('.op-options')].map(group => group.querySelector('input:checked')?.value);
    const resolveVariant = () => variants.find(variant => variant.options?.every((option, i) => option === selectedOptions()[i]));
    const updateVariant = variant => {
      if (!variant) return;
      variantId.value = variant.id;
      variantId.dispatchEvent(new Event('change', { bubbles: true }));
      if (installmentVariantId) {
        installmentVariantId.value = variant.id;
        installmentVariantId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const selectedColor = variant.options?.[colorOptionIndex];
      const visual = variantRadios.find(input => input.dataset.variantColor === selectedColor);
      if (visual) {
        visual.checked = true;
        if (selectedVariantLabel) selectedVariantLabel.textContent = visual.dataset.variantColor || variant.title;
      }
      if (price) price.textContent = formatMoney(variant.price);
      const image = variant.featured_media?.preview_image?.src || variant.featured_image?.src || visual?.dataset.image;
      if (image && mainImage) {
        setMainImage(image);
        syncActiveThumb(image);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        const buttonLabel = addButton.querySelector('span');
        if (buttonLabel) buttonLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      productForm?.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      document.dispatchEvent(new CustomEvent('orion:variant:change', { detail: { variant, sectionId: root.dataset.sectionId } }));
    };

    thumbs.forEach((button, i) => button.addEventListener('click', event => {
      event.preventDefault();
      showMedia(i);
    }));
    root.querySelector('.op-gallery-arrow--left')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      showMedia(activeMedia - 1);
    });
    root.querySelector('.op-gallery-arrow--right')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      showMedia(activeMedia + 1);
    });
    let swipeStartX = null;
    mainMedia?.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse') return;
      swipeStartX = event.clientX;
    }, { passive: true });
    mainMedia?.addEventListener('pointerup', event => {
      if (swipeStartX === null) return;
      const distance = event.clientX - swipeStartX;
      swipeStartX = null;
      if (Math.abs(distance) < 38) return;
      showMedia(activeMedia + (distance < 0 ? 1 : -1));
    }, { passive: true });
    mainMedia?.addEventListener('pointercancel', () => { swipeStartX = null; }, { passive: true });
    const quantity = root.querySelector('.op-qty input');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => quantity.value = Math.max(1, Number(quantity.value || 1) - 1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => quantity.value = Number(quantity.value || 1) + 1);
    root.querySelectorAll('.op-options input').forEach(input => input.addEventListener('change', () => {
      input.closest('.op-options').querySelector('[data-option-label]').textContent = input.value;
      updateVariant(resolveVariant());
    }));
    variantRadios.forEach(input => input.addEventListener('change', () => {
      const colorGroup = root.querySelector('[data-color-option]');
      const colorInput = [...(colorGroup?.querySelectorAll('input') || [])].find(item => item.value === input.dataset.variantColor);
      if (colorInput) colorInput.checked = true;
      const colorLabel = colorGroup?.querySelector('[data-option-label]');
      if (colorLabel) colorLabel.textContent = input.dataset.variantColor;
      if (selectedVariantLabel) selectedVariantLabel.textContent = input.dataset.variantColor;
      updateVariant(resolveVariant());
    }));

    root.querySelectorAll('[data-open-full-specs]').forEach(link => link.addEventListener('click', event => {
      const details = root.querySelector('[data-full-specs-details]');
      if (!details) return;
      event.preventDefault();
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => details.querySelector('summary')?.focus({ preventScroll: true }), 450);
    }));

    root.querySelectorAll('.op-accessory-add[data-accessory-variant]').forEach(button => button.addEventListener('click', async () => {
      if (button.disabled || button.dataset.loading === 'true') return;
      const cartDrawer = document.querySelector('cart-drawer');
      const originalLabel = button.textContent;
      button.dataset.loading = 'true';
      button.disabled = true;
      button.textContent = 'ADDING…';
      try {
        const formData = new FormData();
        formData.append('id', button.dataset.accessoryVariant);
        formData.append('quantity', '1');
        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map(section => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement?.(button);
        }
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
        if (cartDrawer?.renderContents && result.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(result);
        } else {
          cartDrawer?.open?.(button);
        }
        const cartResponse = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.oh-cart-count').forEach(node => { node.textContent = cart.item_count; });
        }
        button.textContent = 'ADDED ✓';
        window.setTimeout(() => { button.textContent = originalLabel; }, 1600);
      } catch (error) {
        button.textContent = 'TRY AGAIN';
        window.setTimeout(() => { button.textContent = originalLabel; }, 1800);
      } finally {
        button.dataset.loading = 'false';
        button.disabled = false;
      }
    }));

    productForm?.addEventListener('submit', async event => {
      if (event.submitter && event.submitter !== addButton) return;
      if (event.defaultPrevented) return;
      event.preventDefault();
      if (!addButton || addButton.disabled || root.dataset.adding === 'true') return;

      const cartDrawer = document.querySelector('cart-drawer');
      const originalLabel = addButton.querySelector('span')?.textContent || 'ADD TO CART';
      root.dataset.adding = 'true';
      addButton.setAttribute('aria-disabled', 'true');
      addButton.classList.add('is-loading');
      if (addButton.querySelector('span')) addButton.querySelector('span').textContent = 'ADDING…';
      if (formStatus) formStatus.textContent = '';

      try {
        const formData = new FormData(productForm);
        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map(section => section.id).join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement?.(addButton);
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');

        if (cartDrawer?.renderContents && result.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(result);
        } else if (cartDrawer?.open) {
          cartDrawer.open(addButton);
        }

        const cartResponse = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.oh-cart-count').forEach(node => { node.textContent = cart.item_count; });
        }
        if (formStatus) formStatus.textContent = 'Added to cart.';
      } catch (error) {
        if (formStatus) formStatus.textContent = error.message;
      } finally {
        root.dataset.adding = 'false';
        addButton.removeAttribute('aria-disabled');
        addButton.classList.remove('is-loading');
        if (addButton.querySelector('span')) addButton.querySelector('span').textContent = originalLabel;
      }
    });

    if (mainImage) {
      if (window.matchMedia('(max-width: 760px)').matches && mainMedia?.dataset.mobileSrc) {
        setMainImage(mainMedia.dataset.mobileSrc);
      }
      syncActiveThumb(mainImage.src);
    }
  };
  document.querySelectorAll('[data-orion-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-orion-product]')));
})();
